<template>
  <div id="printMe">
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <h5 class="card-title" id="accordion">Filtrar arremates</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="endereco_estado">Mês DE</label>
              <input :disabled="desativar_filtro_data" id="dataInicio" class="form-control" name="dataInicio" type="month" v-model="mesInicio" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="endereco_estado">Mês ATÉ</label>
              <input :disabled="desativar_filtro_data" id="dataFim" class="form-control" name="dataFim" type="month" v-model="mesFim" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="leilao_1_modalidade">Tipo leilão</label>

              <select class="custom-select rounded-0" id="leilao_tipo" v-model="tipo_leilao" style="text-transform: uppercase">
                <option value=""></option>
                <option value="extra">Extra</option>
                <option value="judicial">Judicial</option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="comitente">Comitente</label>

              <select class="custom-select rounded-0" id="comitente" v-model="comitente_selecionado">
                <option value=""></option>
                <option v-for="comitente in comitentes" :key="comitente" :value="comitente" style="text-transform: uppercase">
                  {{ comitente.nome }} - {{ comitente.cidade }} / {{ comitente.estado }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="cpf_cnpj">Leilão id</label>
              <input class="form-control" v-model="leilao_id" @keyup="disabledDate()" style="text-transform: uppercase" />
            </div>
          </div>
          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarLotes">Buscar</button>
              <button style="margin-left: 15px" type="button" class="btn btn-default" @click="limparFiltros">Limpar filtros</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button style="margin-left: 5px" data-dismiss="modal" aria-hidden="true" @click="print" class="btn btn-info">
      Imprimir
      <i style="margin-left: 5px" class="fa-solid fa-print"></i>
    </button>

    <button style="margin-left: 5px" class="btn btn-info" @click="ExportExcel('xlsx')">
      Download excel
      <i style="margin-left: 5px" class="fa-solid fa-download"></i>
    </button>

    <div class="card">
      <div class="card-body table-responsive p-0">
        <table class="table table-hover" style="position: relative">
          <thead>
            <tr>
              <th>Mês</th>
              <th>Data</th>
              <th>Tipo</th>
              <th>Vara - Comitente - Comarca</th>
              <th>Autos</th>
              <th>Leilão</th>
              <th>Lote</th>
              <th>Praça</th>
              <th>
                Arrematante
                <br />
                Nome/CPF
              </th>
              <th>Valor arrematação</th>
              <th>Valor comissão</th>
              <th>Taxa adm.</th>
              <th>Forma pagamento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lote, index) in lotes" :key="lote">
              <td>{{ formatDateMes(lote.lote_lance_data) }}</td>
              <td>{{ formatOnlyDate(lote.lote_lance_data) }}</td>
              <td>
                <span style="text-transform: uppercase">{{ lote.leilao_tipo }}</span>
              </td>

              <td>
                <span v-if="lote.leilao.comitente" style="text-transform: uppercase">{{ lote.leilao.comitente.nome }} -&nbsp;</span>

                <span v-if="lote.leilao.comitente" style="text-transform: uppercase">
                  {{ lote.leilao.comitente_completo.cidade }} - {{ lote.leilao.comitente_completo.estado }}
                </span>
              </td>

              <td>
                <span v-if="lote.processo">
                  {{ lote.processo.processo_numero }}
                </span>
              </td>

              <td>
                <span style="text-transform: uppercase">{{ lote.leilao_id }} - {{ lote.leilao.leilao_titulo }}</span>
              </td>

              <td>
                <span style="text-transform: uppercase">{{ lote.lote_numero }} - {{ lote.lote_titulo }}</span>
              </td>

              <td>
                <span>{{ lote.lote_lance_praca }}</span>
              </td>

              <td>
                <span>{{ lote.user_id }} - {{ lote.apelido }} - {{ lote.nome_completo }} - {{ formatarCPF(lote.cpf) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency(lote.lote_lance) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency((lote.lote_comissao / 100) * lote.lote_lance) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency(lote.leilao_taxa_administrativa) }}</span>
              </td>

              <td style="text-transform: uppercase">
                <span v-if="lote.lote_ultimo_lance_parcelado">PARCELADO</span>
                <span v-else>À VISTA</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <span>R${{ calcularTotalArrematacao() }}</span>
              </td>
              <td>
                <span>R${{ calcularValorComissao() }}</span>
              </td>
              <td>
                <span>R${{ calcularTaxaAdm() }}</span>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <table v-show="false" class="table table-hover" style="position: relative" ref="exportable_table">
          <thead>
            <tr>
              <th>Mês</th>
              <th>Data</th>
              <th>Tipo</th>
              <th>Vara - Comitente - Comarca</th>
              <th>Autos</th>
              <th>Leilão</th>
              <th>Lote</th>
              <th>Praça</th>
              <th>
                Arrematante
                <br />
                Nome/CPF
              </th>
              <th>Valor arrematação</th>
              <th>Valor comissão</th>
              <th>Taxa adm.</th>
              <th>Forma pagamento</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lote, index) in lotes" :key="lote">
              <td>{{ formatDateMes(lote.lote_lance_data) }}_</td>
              <td>{{ formatOnlyDate(lote.lote_lance_data) }}_</td>
              <td>
                <span style="text-transform: uppercase">{{ upperCase(lote.leilao_tipo) }}</span>
              </td>

              <td>
                <span v-if="lote.leilao.comitente" style="text-transform: uppercase">{{ lote.leilao.comitente.nome }} -&nbsp;</span>

                <span v-if="lote.leilao.comitente" style="text-transform: uppercase">
                  {{ lote.leilao.comitente_completo.cidade }} - {{ lote.leilao.comitente_completo.estado }}
                </span>
              </td>

              <td>
                <span v-if="lote.processo" style="text-transform: uppercase">
                  {{ upperCase(lote.processo.processo_numero) }}
                </span>
              </td>

              <td style="text-transform: uppercase">
                <span>{{ lote.leilao_id }} - {{ upperCase(lote.leilao.leilao_titulo) }}</span>
              </td>

              <td>
                <span style="text-transform: uppercase">{{ lote.lote_numero }} - {{ upperCase(lote.lote_titulo) }}</span>
              </td>

              <td>
                <span>{{ lote.lote_lance_praca }}</span>
              </td>

              <td>
                <span>{{ lote.user_id }} - {{ lote.apelido }} - {{ lote.nome_completo }} - {{ formatarCPF(lote.cpf) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency(lote.lote_lance) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency((lote.lote_comissao / 100) * lote.lote_lance) }}</span>
              </td>

              <td>
                <span>R$ {{ toCurrency(lote.leilao_taxa_administrativa) }}</span>
              </td>

              <td style="text-transform: uppercase">
                <span v-if="lote.lote_ultimo_lance_parcelado">PARCELADO</span>
                <span v-else>À VISTA</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <span>R${{ calcularTotalArrematacao() }}</span>
              </td>
              <td>
                <span>R${{ calcularValorComissao() }}</span>
              </td>
              <td>
                <span>R${{ calcularTaxaAdm() }}</span>
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import auxFormatacao from "../../controller/auxFormatacao.js";
import sweetAlert from "../../controller/sweetAlert.js";
import currencyController from "../../controller/currencyController.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment, { relativeTimeThreshold } from "moment";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: ["estados"],

  mixins: [sweetAlert, Swal, AuxController, currencyController, auxFormatacao],

  components: [Loading],

  data() {
    return {
      isLoading: false,
      leilao_selecionado: "",
      filtro: "",
      paginas: [],
      inicio: 0,
      total: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      lotes: [],
      cidades: [],
      id: "",
      estado: "",
      cidade: "",
      comitente: "",
      venda_direta: false,
      relatorio_selecionado: "",
      listar_lotes: true,
      titulo: "",
      descricao: "",
      dataInicio: "",
      dataFim: "",
      exibir_propostas: false,
      processos: "",
      comitentes: "",
      lote_selecionado: "",
      mesInicio: "",
      mesFim: "",
      tipo_leilao: "",
      comitente_selecionado: "",
      leilao_id: "",
      desativar_filtro_data: false,
    };
  },

  mounted() {
    console.log(this.docs_tipo_usuario);

    this.dataInicio = this.formatSelectedDate(new Date());
    this.dataFim = this.formatSelectedDate(new Date());

    this.mesInicio = moment(new Date()).format("YYYY-MM");
    this.mesFim = moment(new Date()).format("YYYY-MM");

    //this.buscarLotes();
    this.buscarComitentes();
    //this.buscarprocessos();
  },

  methods: {
    disabledDate() {
      if (this.leilao_id != "") {
        this.desativar_filtro_data = true;

        this.mesInicio = "";
        this.mesFim = "";

        document.getElementById("dataInicio").value = "";
        document.getElementById("dataFim").value = "";
      } else {
        this.enableData();
      }
    },

    enableData() {
      this.desativar_filtro_data = false;

      this.dataInicio = this.formatSelectedDate(new Date());
      this.dataFim = this.formatSelectedDate(new Date());

      this.mesInicio = moment(new Date()).format("YYYY-MM");
      this.mesFim = moment(new Date()).format("YYYY-MM");
    },

    upperCase(string) {
      if (!string) {
        return string;
      }

      return string.toUpperCase();
    },

    ExportExcel(type, fn, dl) {
      let nome_arquivo = "Relatório arremate";
      var elt = this.$refs.exportable_table; // A tabela que você quer exportar

      // Criação do livro a partir da tabela principal
      var wb = XLSX.utils.table_to_book(elt, { sheet: "Relatório completo" });

      // Dados do array "lotes" - este array contém todos os lances
      const lotes = this.lotes; // Supondo que "lotes" seja a lista que contém os dados

      // Organizar os lances por mês/ano
      const lancesPorMesAno = {};

      lotes.forEach((lote) => {
        const date = new Date(lote.lote_lance_data);
        const mesAno = `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`; // Formato MM-YYYY

        // Se o mês/ano ainda não existir no objeto, cria um array vazio para ele
        if (!lancesPorMesAno[mesAno]) {
          lancesPorMesAno[mesAno] = [];
        }

        // Adiciona o lance ao mês/ano correspondente
        lancesPorMesAno[mesAno].push([
          this.formatDateMes(lote.lote_lance_data),
          this.formatOnlyDate(lote.lote_lance_data),
          lote.leilao_tipo.toUpperCase(),
          `${lote.leilao.comitente ? lote.leilao.comitente.nome : ""} - ${lote.leilao.comitente_completo.cidade} - ${
            lote.leilao.comitente_completo.estado
          }`,
          lote.processo ? lote.processo.processo_numero.toUpperCase() : "",
          `${lote.leilao_id} - ${lote.leilao.leilao_titulo.toUpperCase()}`,
          `${lote.lote_numero} - ${lote.lote_titulo.toUpperCase()}`,
          lote.lote_lance_praca,
          `${lote.user_id} - ${lote.apelido} - ${lote.nome_completo} - ${this.formatarCPF(lote.cpf)}`,
          `R$ ${this.toCurrency(lote.lote_lance)}`,
          `R$ ${this.toCurrency((lote.lote_comissao / 100) * lote.lote_lance)}`,
          `R$ ${this.toCurrency(lote.leilao_taxa_administrativa)}`,
          lote.lote_ultimo_lance_parcelado ? "PARCELADO" : "À VISTA",
        ]);
      });

      // Criar uma aba para cada mês/ano com os dados filtrados
      Object.keys(lancesPorMesAno).forEach((mesAno) => {
        const dados = lancesPorMesAno[mesAno];

        // Criar o cabeçalho da nova aba
        const cabecalho = [
          "Mês",
          "Data",
          "Tipo",
          "Vara - Comitente - Comarca",
          "Autos",
          "Leilão",
          "Lote",
          "Praça",
          "Arrematante Nome/CPF",
          "Valor arrematação",
          "Valor comissão",
          "Taxa adm.",
          "Forma pagamento",
        ];

        // Adicionar os dados na nova aba
        wb.SheetNames.push(mesAno); // Nome da aba: mês-ano
        wb.Sheets[mesAno] = XLSX.utils.aoa_to_sheet([cabecalho].concat(dados)); // Cabeçalho + dados

        // Adicionar a linha de totais
        const linhaTotais = [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          `R$ ${this.calcularTotalArrematacao(mesAno)}`,
          `R$ ${this.calcularValorComissao(mesAno)}`,
          `R$ ${this.calcularTaxaAdm(mesAno)}`,
          "",
          "",
          "",
        ];

        // Adiciona a linha de totais na última linha
        XLSX.utils.sheet_add_aoa(wb.Sheets[mesAno], [linhaTotais], { origin: -1 });
      });

      // Exportar o arquivo
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || (nome_arquivo + "." || "SheetJSTableExport.") + (type || "xlsx"));
    },

    // Calcular a Taxa Adm. considerando apenas o mês/ano
    calcularTaxaAdm(mesAno) {
      if (mesAno) {
        let total_taxa_adm = 0;

        this.lotes
          .filter((lote) => {
            const date = new Date(lote.lote_lance_data);
            const loteMesAno = `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            return loteMesAno === mesAno; // Filtra apenas os lances do mês/ano
          })
          .forEach((lote) => {
            total_taxa_adm += lote.leilao.leilao_taxa_administrativa;
          });

        return this.toCurrency(total_taxa_adm);
      } else {
        return this.toCurrency(this.lotes.reduce((soma, lote) => soma + lote.leilao_taxa_administrativa, 0));
      }
    },

    // Calcular o Valor da Comissão considerando apenas o mês/ano
    calcularValorComissao(mesAno) {
      if (mesAno) {
        let total_arrematacao = 0;

        this.lotes
          .filter((lote) => {
            const date = new Date(lote.lote_lance_data);
            const loteMesAno = `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            return loteMesAno === mesAno; // Filtra apenas os lances do mês/ano
          })
          .forEach((lote) => {
            total_arrematacao += (lote.lote_comissao / 100) * lote.lote_lance;
          });

        return this.toCurrency(total_arrematacao);
      } else {
        return this.toCurrency(this.lotes.reduce((soma, lote) => soma + (lote.lote_comissao / 100) * lote.lote_lance, 0));
      }
    },

    // Calcular o Total da Arrematação considerando apenas o mês/ano
    calcularTotalArrematacao(mesAno) {
      if (mesAno) {
        let total_arrematacao = 0;

        this.lotes
          .filter((lote) => {
            const date = new Date(lote.lote_lance_data);
            const loteMesAno = `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
            return loteMesAno === mesAno; // Filtra apenas os lances do mês/ano
          })
          .forEach((lote) => {
            total_arrematacao += lote.lote_lance;
          });

        return this.toCurrency(total_arrematacao);
      } else {
        return this.toCurrency(this.lotes.reduce((soma, lote) => soma + lote.lote_lance, 0));
      }
    },

    print() {
      const options = {
        name: "Relatório leilão",
        specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
        styles: [
          "../../css/print.css",
          "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
        ],
        timeout: 1000, // default timeout before the print window appears
        autoClose: true, // if false, the window will not close after printing
        windowTitle: window.document.title, // override the window title
      };

      //htmlToPaper("printMe");

      this.$htmlToPaper("printMe", options);
    },

    formatSelectedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },

    buscarComitentes() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
        alfabetico: true,
      };

      axios
        .post(`/admin/comitente/search`, data)
        .then((response) => {
          this.comitentes = response.data.comitentes;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    buscarprocessos() {
      this.isLoading = true;

      let data = {
        inicio: 0,
        tamanho: 100000,
      };

      console.log("Buscando");
      console.log(data);

      axios
        .post(`/admin/processos/search`, data)
        .then((response) => {
          this.processos = response.data.processos;
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    setListarProposta() {
      this.exibir_propostas = false;
    },

    getValorLance(lance) {
      return "R$" + this.toCurrency(lance.valor);
    },

    getValorLanceSemConversao(lance) {
      return lance.valor;
    },

    getLoteDescription(description) {
      if (typeof description == "string" && description.includes("</")) {
        //console.log("Entrou no IF");
        var div = document.createElement("div");
        div.innerHTML = description;
        description = div.textContent || div.innerText || "";
      } else {
        // console.log("Descricao fora do IF");
      }

      if (description && description.length > 210) {
        return description.substring(0, 210) + "...";
      }
      return description;
    },

    getFormatedText(text, size) {
      if (text && text.length > size) {
        return text.substring(0, size) + "...";
      } else {
        return text;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    buscarLotes() {
      this.isLoading = true;

      let data = {
        id: this.id,
        comitente_id: this.comitente,
        titulo: this.titulo,
        descricao: this.descricao,
        inicio: this.inicio,
        tamanho: 10000000,
        executado: this.executado,
        tipo_leilao: this.tipo_leilao,
        leilao_id: this.leilao_id,
      };

      if (this.mesInicio) {
        data.inicio_mes = moment(this.mesInicio, "YYYY-MM").format("MM");
        data.inicio_ano = moment(this.mesInicio, "YYYY-MM").format("yyyy");
      }

      if (this.mesFim) {
        data.fim_mes = moment(this.mesFim, "YYYY-MM").format("MM");
        data.fim_ano = moment(this.mesFim, "YYYY-MM").format("yyyy");
      }

      if (this.comitente_selecionado) {
        data.comitente_id = this.comitente_selecionado.id;
      }

      /*
      if (this.dataInicio) {
        console.log("Formatando");
        console.log(this.dataInicio);

        data.data_inicio = this.formatDateToSearch(this.dataInicio);
      }

      if (this.dataFim) {
        data.data_fim = this.formatDateToSearchTime(this.dataFim);
      }
    */

      console.log(data);

      axios
        .post(`/admin/relatorio/analitico/search`, data)
        .then((response) => {
          this.lotes = response.data.lotes;
          this.total = response.data.total;

          console.log("Leilões");
          console.log(this.lotes);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    formatDateMes(date) {
      return moment(date).format("MM-YY");
    },

    formatDateToSearch(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 00:00:00");
    },

    formatDateToSearchTime(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 23:59:59");
    },

    changePraca(leilao, num_praca) {
      console.log(leilao.leilao_1_realizado);
      console.log(num_praca);

      this.leilao_selecionado = leilao;

      let valor = -1;

      //FECHANDO PRACA
      if (num_praca == 2 && leilao.leilao_2_realizado && !leilao.leilao_1_realizado) {
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 3 && leilao.leilao_3_realizado && !leilao.leilao_2_realizado) {
        leilao.leilao_3_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else if (num_praca == 4 && leilao.leilao_4_realizado && !leilao.leilao_3_realizado) {
        leilao.leilao_4_realizado = false;
        this.showErrorMessageWithButton("Ops...", "A praça anterior não está fechada ainda.");
      } else {
        if (num_praca == 1) {
          valor = this.convertToTiny(leilao.leilao_1_realizado);
        } else if (num_praca == 2) {
          valor = this.convertToTiny(leilao.leilao_2_realizado);
        } else if (num_praca == 3) {
          valor = this.convertToTiny(leilao.leilao_3_realizado);
        } else if (num_praca == 4) {
          valor = this.convertToTiny(leilao.leilao_4_realizado);
        }

        let data = {
          leilao_id: leilao.id,
          num_praca: num_praca,
          valor: valor,
        };

        console.log(data);

        axios
          .post(`/admin/leilao/fechar_praca`, data)
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              if (response.data.leilao_aberto) {
                leilao.leilao_encerrado = false;
              }

              if (response.data.leilao_encerrado) {
                leilao.leilao_encerrado = true;
              }

              this.showSuccessMessage("Status atualizado");
              this.forceDisconnect();
            } else {
              console.log("Erro na request");
              this.showErrorMessageWithButton("Ops...", response.data.msg);
              this.buscarLotes();
            }

            //window.location.reload();
          })
          .catch((error) => {
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
            this.isLoading = false;
          });
      }
    },

    forceDisconnect() {
      let data = {
        leilao_id: this.leilao_selecionado.id,
      };

      axios.post(process.env.MIX_VUE_APP_AUDITORIO + `/emit_disconnect`, data).then((response) => {});
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";
    },

    onRightClick(event, leilao) {
      this.leilao_selecionado = leilao;

      let newMenu = document.getElementById("newMenu");
      let x = event.clientX - 300;
      let y = event.pageY - 250;

      let winWidth = window.innerWidth;
      let cmWidth = newMenu.offsetWidth;

      x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

      console.log("X depois " + x);

      newMenu.style.top = y + "px";
      newMenu.style.left = x + "px";
      newMenu.style.visibility = "visible";
    },

    changeStatus(leilao, atual) {
      console.log(leilao);

      this.leilao_selecionado = leilao;

      let data = {
        leilao_id: leilao.id,
        leilao_retirado: this.convertToTiny(leilao.leilao_retirado),
        leilao_encerrado: this.convertToTiny(leilao.leilao_encerrado),
        leilao_suspenso: this.convertToTiny(leilao.leilao_suspenso),
      };

      console.log(data);

      axios
        .post(`/admin/leilao/atualizar_status`, data)
        .then((response) => {
          this.showSuccessMessage("Status atualizado");
          this.forceDisconnect();

          //window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    ocultarLeilao(leilao) {
      let mensagem = "";

      if (!leilao.leilao_oculto) {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: green'>desocultar</b> o leilão, todos os lotes também serão desocultados. <br/><b>Confirma sua escolha?</b></h3>";
      } else {
        mensagem =
          "<h3 style='color:#616060'>Ao <b style='color: red'>ocultar</b> o leilão, todos os lotes serão marcados com oculto. <br/><b>Confirma sua escolha?</b></h3>";
      }

      this.$swal
        .fire({
          title: mensagem,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, confirmar!",
        })
        .then((result) => {
          if (result.value) {
            let data = {
              leilao_id: leilao.id,
              leilao_oculto: this.convertToTiny(leilao.leilao_oculto),
            };

            console.log(data);

            axios
              .post(`/admin/leilao/ocultar_leilao`, data)
              .then((response) => {
                this.showSuccessMessage("Status atualizado");

                //window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButton("Ops..", error);
                console.log(error);
                this.isLoading = false;
              });
          } else {
            leilao.leilao_oculto = !leilao.leilao_oculto;
          }
        });
    },

    handler() {
      alert("Right!");
    },

    getUrlImportarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/importar";
    },

    getUrlFotos(leilao) {
      if (leilao.lotes && leilao.lotes.length) {
        return "/admin/fotos/" + leilao.lotes[0].id + "";
      }
    },

    getUrlPub(leilao) {
      return "/admin/publicacao/" + leilao.id + "";
    },

    getUrlDocumentos(leilao) {
      return "/admin/documentos/" + leilao.id + "";
    },

    getUrlListarLotes(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes";
    },

    getUrlAddLote(leilao) {
      return "/admin/leilao/" + leilao.id + "/lotes/cadastrar_lote";
    },

    getUrlLogs(leilao) {
      return "/admin/leilao/" + leilao.id + "/logs";
    },

    limparFiltros() {
      this.id = "";
      this.estado = "";
      this.cidade = "";
      this.comitente = "";
      this.titulo = "";
      this.descricao = "";
      //this.local = "EXCLUSIVAMENTE ONLINE";
      this.local = "";
      this.tipo = "";
      this.teste = 0;
      this.executado = "";
      this.processo = "";
      this.dataInicio = "";
      this.dataFim = "";

      this.comitente_selecionado = null;
      this.tipo_leilao = null;
      this.leilao_id = null;

      this.mesInicio = "";
      this.mesFim = "";

      document.getElementById("dataInicio").value = "";
      document.getElementById("dataFim").value = "";

      //this.buscarLotes();
    },

    calcularValor(created_at) {
      let dataReferencia = this.formatToCompare(new Date());
      let data = this.formatToCompare(created_at);

      var duration = moment.duration(dataReferencia.diff(data));
      var hours = duration.asHours();

      if (hours < 1) {
        var min = duration.asMinutes();
        return ~~min + " min.";
      } else if (hours >= 24) {
        var days = duration.asDays();
        return ~~days + " dias";
      } else {
        return ~~hours + " horas";
      }
    },

    visualizar(leilao) {
      this.leilao_selecionado = leilao;
    },

    formatToCompare(date) {
      return moment(date);
    },

    convertTiny(value) {
      if (value == 0) {
        return "Não";
      } else {
        return "Sim";
      }
    },

    convertToTiny(value) {
      if (value) {
        return 1;
      } else {
        return 0;
      }
    },

    getUrlEdit(leilao) {
      return "/admin/leilao/" + leilao.id;
    },

    show(leilao) {
      this.leilao_selecionado = leilao;
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas.length && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;
        this.buscarLotes();
      }
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.estado,
      };

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.cidades = response.data.cidades;

          console.log(response.data);

          this.isLoading = false;

          this.buscarLotes();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    getImageLote(lote) {
      if (lote.thumb) {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + lote.thumb.path + "/" + lote.thumb.img;
      } else {
        return "/images/logo.png";
      }
    },

    getImagePath(logo) {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + logo.path + "/" + logo.arquivo;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarLotes();
    },

    deletar(leilao) {
      this.leilao_selecionado = leilao;

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o tipo de leilao<b><br/>" + this.leilao_selecionado.nome + "</b>? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: this.leilao_selecionado.id,
            };

            axios
              .post(`/admin/leilao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("leilao deletado!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.leilao_selecionado.id,
        cadastro_tipo: this.leilao_selecionado.cadastro_tipo,
        tipodoc: this.leilao_selecionado.tipodoc,
        estado_civil: this.leilao_selecionado.estado_civil,
        obrigatorio: this.leilao_selecionado.obrigatorio,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/documento_tipo_usuario/update`, data)
        .then((response) => {
          this.showSuccessMessage("Estilo atualizado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    formatOnlyDate(date) {
      return moment(date).format("DD/MM/YYYY ");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}

.realizado {
  text-decoration: line-through;
}
</style>
